import React, { useEffect, useState } from 'react'
import { useUpdateUserEmailMutation } from '../../../services/authApi';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { toast } from 'react-toastify';
import TextField from '../../../components/textFields/TextField';
import { KTSVG } from '../../../_metronic/helpers';
import { Modal } from 'react-bootstrap';
import labelKey from '../../localization/label.json'
type Props = {
    show: boolean
    handleClose: () => void
    data?: any
    refetch?: any
}
const UpdateUserEmailModal = ({ show, handleClose, data, refetch }: Props) => {
    console.log(data);
    const initialValues = {
        userAccountID: 0,
        email: ''
    }
    const [id, setId] = useState(0);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const [updateEmailApiTrigger, { data: updateEmailData, isLoading, isSuccess, isError, error }] = useUpdateUserEmailMutation()




    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email('Invalid email format')
            .required('Email is required'),
    });

    useEffect(() => {
        if (data) {
            setId(data?.userAccountID);
            formik.setValues({
                userAccountID: data?.userAccountID,
                email: data?.email,
            })
        } else if (!show) {
            setId(0);
            formik.resetForm();
        }
    }, [show, data]);
    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            updateEmailApiTrigger(values)
        }
    })

    useEffect(() => {
        if (isSuccess) {
            const responseData = (updateEmailData as any)?.message;
            const successMessage = responseData;
            toast.success(successMessage);
            handleClose();
            setShowConfirmation(false);
            refetch();
        }
    }, [isSuccess, updateEmailData]);


    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);

    const handleModalClose = () => {
        handleClose();
        setShowConfirmation(false)
    };
    return (
        <>
            <Modal
                aria-hidden='true'
                dialogClassName='modal-dialog modal-md modal-dialog-centered'
                show={show}
                onHide={handleModalClose}
            >
                <div className='modal-header'>
                    <h2 className='mb-0'>Update User Email</h2>
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleModalClose}>
                        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                    </div>
                </div>

                <form
                    className='form w-100'
                    onSubmit={(e) => {
                        e.preventDefault();
                        formik.handleSubmit();
                    }}
                >
                    {!showConfirmation &&
                        <>
                            <div className='modal-body py-lg-10 px-lg-10'>
                                <TextField
                                    label={labelKey.email}
                                    required={true}
                                    type='email'
                                    placeholder='Enter Email'
                                    {...formik.getFieldProps('email')}
                                />
                                {formik.touched.email && formik.errors.email && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>
                                            <span role='alert'>{formik.errors.email}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='modal-footer justify-content-center'>
                                <span className='btn btn-light' onClick={handleModalClose}>{labelKey.cancel}</span>
                                <span className='btn btn-primary' onClick={() => setShowConfirmation(true)}>{labelKey.submit}</span>

                                {/* <button
                            type='submit'
                            className='btn btn-primary mb-5 mt-5'
                            disabled={isLoading}
                        >
                            {!isLoading && <span className='indicator-label'>{labelKey.submit}</span>}
                            <>
                                {isLoading && (
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        {labelKey.pleaseWait}...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                    </span>
                                )}
                            </>
                        </button> */}
                            </div>
                        </>
                    }
                    {showConfirmation &&
                        <div className='card'>
                            <div className="card-body">
                                <p className='text-center fs-4'>
                                    Your current email <span className='text-bold text-primary'>{data.email}</span> will be removed from your account. Upon confirmation, your new email <span className='text-bold text-primary'>{formik.values.email}</span> will become your login credential.
                                </p>
                                <div className='d-flex gap-3 justify-content-center py-4 pb-3 mt-5'>
                                    <div className='btn btn-light' onClick={() => setShowConfirmation(false)}>{labelKey.cancel}</div>
                                    <button
                                        type='submit'
                                        className='btn btn-primary'
                                        disabled={isLoading}
                                    >
                                        {!isLoading && <span className='indicator-label px-5'>{labelKey.yes}</span>}
                                        <>
                                            {isLoading && (
                                                <span className='indicator-progress' style={{ display: 'block' }}>
                                                    {labelKey.pleaseWait}...
                                                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                </span>
                                            )}
                                        </>
                                    </button>
                                </div>
                            </div>
                        </div>
                    }
                </form>
            </Modal>


        </>
    )
}

export default UpdateUserEmailModal